import { BORDER_COLORS, SURFACE_COLORS, TEXT_COLORS } from '@constants/colors.ts';
import { STYLED_COMPONENTS_TEXT } from '@constants/text.ts';
import styled from 'styled-components';

export interface StyledCardProps {
    $source: string;
    $type: string;
    $isExpanded: boolean;
    $wasRead?: boolean;
    $isNew?: boolean;
}

const getBorderColor = (type: string, source: string): string => {
    if (source === 'System') {
        return BORDER_COLORS.body;
    }

    switch (type) {
        case 'Completed':
        case 'Passed':
            return BORDER_COLORS.accepted;
        case 'Failed':
        case 'Aborted':
        case 'Overdue':
            return BORDER_COLORS.error;
        case 'Reminder':
        case 'FinalReminder':
            return BORDER_COLORS.warning;
        case 'Info':
            return BORDER_COLORS.neutral;
        default:
            return BORDER_COLORS.focus;
    }
};

export const Card = styled.div<StyledCardProps>`
    --status-color: ${({ $type, $source }) => getBorderColor($type, $source)};
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    align-self: stretch;
    border-radius: var(--spacing-xs, 8px);
    border: 1px solid ${BORDER_COLORS.primary};
    ${({ $isNew, $wasRead }) => ($isNew || !$wasRead) && `background: ${SURFACE_COLORS.primary};`}
    border-left-color: var(--status-color);
    border-color: ${({ $type, $isExpanded, $source }) => $isExpanded && getBorderColor($type, $source)};
    border-left-width: 4px;
`;

export const CardHeader = styled.div`
    display: flex;
    width: 100%;
`;

export const ButtonRead = styled(STYLED_COMPONENTS_TEXT['body/sm/sm-medium'])`
    display: flex;
    padding: 10px var(--spacing-sm, 16px);
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: var(--border-radius-s_8, 8px);
    border: var(--border-width-sm_1, 1px) solid rgba(33, 113, 198, 0.4);
    background: ${SURFACE_COLORS.primary};
    color: ${TEXT_COLORS.information};
    cursor: pointer;
    width: 132px;
`;

interface StyledClockProps {
    stroke: string;
}
export const ClockWrapper = styled.span<StyledClockProps>`
    width: 16px;
    height: 16px;
    svg {
        stroke: ${({ stroke }) => stroke};
    }
`;

export const NonOptOutIndicator = styled.div`
    position: absolute;
    right: 0;
    cursor: pointer;
`;
